/**
 * A component to show a summary of the charge account
 *
 * @param chargeAccountId the charge account id to be used in navigation
 * @param currentBalance the balance value to be displayed in the component
 * @param unsettledCharges the value to be displayed in the component
 * @param chargeAccountType the value to be displayed in the component header
 */
export const ChargeAccountSummaryCardComponent: ng.IComponentOptions = {
    bindings: {
        chargeAccountId: '@',
        currentBalance: '@',
        unsettledCharges: '@',
        chargeAccountType: '@'
    },
    templateUrl: 'app/angularJS/components/charge-account-summary-card/charge-account-summary-card.html',
    controller: 'ChargeAccountSummaryCardController',
    controllerAs: 'vm'
};